import { InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";

type Props = {
	value: "UTC" | "Server";
	onChange: (value: "UTC" | "Server") => void;
};

export const TimezoneSelector = ({ value, onChange }: Props) => {
	return (
		<div
			style={{ marginTop: 6, borderTopLeftRadius: 3, borderTopRightRadius: 3 }}
		>
			<InputLabel
				id="timezone-selector-label"
				style={{ fontSize: 10, marginBottom: 0 }}
			>
				Timezone
			</InputLabel>
			<Select
				labelId="timezone-selector-label"
				id="timezone-selector"
				value={value}
				onChange={(event) => onChange(event.target.value as any)}
				style={{ minWidth: "100%" }}
				variant="standard"
			>
				<MenuItem value={"UTC"}>UTC</MenuItem>
				<MenuItem value={"Server"}>Server</MenuItem>
			</Select>
		</div>
	);
};
